import React, { memo, useCallback, useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Checkbox, Typography, Stack, Card, CardHeader, CardContent, Button, IconButton, FormControlLabel, Grid } from '@mui/material';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { CloudDoneOutlined, CloudOffOutlined } from '@mui/icons-material';
import strings from '../../../Globalization/index';
import { DashBoardequipmentModel } from '../../../AppGrid/DashBoardEquipmentTable';
import SelectedLgridIconPNG from '../../../styles/img/assets/selected lgrid icon.png';
import DeselctedGridIconPng from '../../../styles/img/assets/Deselcted Grid icon.png';
import SelectedListIconPng from '../../../styles/img/assets/selected list icon.png';
import DeselctedListIconPng from '../../../styles/img/assets/Deselcted list icon.png';
import consts from '../../../consts';
import { dataStore } from '../../../Store';

const EquipmentTable = DashBoardequipmentModel.createGridBase();
const EquipmentGridListItem = memo(({ data }) => {
	const navigate = useNavigate();
	const isSterilizer = [consts.EquipmentFamilyType.AMSCOEUSTERILIZER, consts.EquipmentFamilyType.STEAMEUSTERILIZER].includes(data.EquipmentFamilyId);
	const isIncubator = [consts.EquipmentFamilyType.IncubatorSteam, consts.EquipmentFamilyType.IncubatorVHP].includes(data.EquipmentFamilyId);
	const currentDate = new Date();
	const lastConnectionDate = new Date(data.LastConnection);
	const hoursDifference = ((currentDate - lastConnectionDate) / 1000) / 60 / 60;
	const location = useLocation();
	const handleClick = () => {
		navigate(`/equipmentinfo?id=${data.EquipmentId}&name=${data.EquipmentName || ''}&isSterilizer=${isSterilizer ? true : false}&isIncubator=${isIncubator ? true : false}&isFromEquipmentDetail=${true}&equipmentType=${data.EquipmentType}&equipmentTypeId=${data.EquipmentTypeId}&returnTo=${encodeURIComponent(location.search)}`, { state: data, previousPath: location.search });
	}

	return (
		<Card variant="hover-shadow" sx={{ height: "max-content", textDecoration: 'none', marginTop: '3rem' }} onClick={handleClick}>
			<CardHeader
				title={
					<Typography variant="body2" color={'primary'} component="span">
						{data?.EquipmentName}
					</Typography>
				}
				action={

					data.LastConnection === '' || data.LastConnection === null || hoursDifference > 24 ?
						<IconButton color={"text.secondary"} aria-label="cloud off"><CloudOffOutlined /></IconButton>
						:
						<IconButton color={"success"} aria-label="cloud done"> <CloudDoneOutlined /></IconButton>
				}
				sx={{ backgroundColor: "#f7f7f7", height: '2.5em', color: '#000' }}
			/>
			<CardContent sx={{ border: '2px solid #e7eaec' }}>
				<Grid container>
					<Grid size={6} sx={{ p: 0.5 }}>
						<Typography variant="body2" color="primary" component="span" gutterBottom sx={{ fontWeight: 'bold' }} > {strings.SNo} </Typography>
					</Grid>
					<Grid size={6} sx={{ p: 0.5 }}>
						<Typography variant="body2" component="span" gutterBottom> {data?.SerialNumber || ""} </Typography>
					</Grid>

					<Grid size={6} sx={{ p: 0.5 }}>
						<Typography variant="body2" color="primary" component="span" gutterBottom sx={{ fontWeight: 'bold' }}>
							{strings.EquipmentType}
						</Typography>
					</Grid>
					<Grid size={6} sx={{ p: 0.5 }}>
						<Typography variant="body2" component="span" gutterBottom >
							{data?.EquipmentType || ""}
						</Typography>
					</Grid>

					<Grid size={6} sx={{ p: 0.5 }}>
						<Typography variant="body2" color="primary" component="span" gutterBottom sx={{ fontWeight: 'bold' }}>
							{strings.ModalName}
						</Typography>
					</Grid>
					<Grid size={6} sx={{ p: 0.5 }}>
						<Typography variant="body2" component="span" gutterBottom>
							{data?.ModelName || ""}
						</Typography>
					</Grid>

					<Grid size={6} sx={{ p: 0.5 }}>
						<Button variant="contained" color="primary"
							sx={{ borderRadius: 999 }}
							size="small"
							startIcon={<i className="fa fa-map-marker" />}>
						</Button>
					</Grid>
					<Grid size={6} sx={{ p: 0.5 }}>
						<Typography variant="body2" component="span" gutterBottom>
							{data.LocationName}
						</Typography>
					</Grid>

					<Grid size={6} sx={{ p: 0.5 }}>
						<Button
							sx={{ borderRadius: 999 }}
							size="small"
							variant="contained"
							color="primary">
							{data?.CycleToday || 0}
						</Button>
					</Grid>

					<Grid size={6} sx={{ display: "flex", alignItems: "center", p: 0.5 }}>
						<Typography variant="body2" component="span" gutterBottom>
							{strings.CyclesToday}
						</Typography>
					</Grid>
				</Grid>
			</CardContent>
		</Card>
	);
});

const EquipmentGridList =  DashBoardequipmentModel.createGridListBase();

const EquipmentListComponent = memo(({ extraParams, equipmentActive, onChangeView, selectedView = 'list', baseFilters, setEquipmentActive, setEquipmentInActive, equipmentInActive, fromModality, dashboardList }) => {
	const theme = useTheme();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const EquipmentTypeId = searchParams.get('EquipmentTypeId');
	const isSterilizer = [consts.EquipmentFamilyType.AMSCOEUSTERILIZER, consts.EquipmentFamilyType.STEAMEUSTERILIZER].includes(dashboardList?.EquipmentFamilyId);
	const isIncubator = [consts.EquipmentFamilyType.IncubatorSteam, consts.EquipmentFamilyType.IncubatorVHP].includes(dashboardList?.EquipmentFamilyId);
	const { auth } = dataStore.getState();
	const parentFilters = useMemo(() => {
		let filters = [];

		if (EquipmentTypeId) {
			filters.push({
				operator: '$eq',
				value: EquipmentTypeId,
				property: 'EquipmentTypeId',
				type: 'numeric'
			});
		}

		if (extraParams?.equipmentTypeId) {
			filters.push({
				operator: '$eq',
				value: extraParams?.equipmentTypeId,
				property: 'equipmentTypeId',
				type: 'numeric'
			});
		}

		if (extraParams?.locationId) {
			filters.push({
				operator: '$eq',
				value: extraParams?.locationId,
				property: 'locationId',
				type: 'numeric'
			});
		}

		if (!extraParams?.disconnected) {
			filters.push({
				operator: '$eq',
				value: false,
				property: 'IsDisConnected',
				type: 'boolean'
			});
		}

		if (!extraParams?.connected) {
			filters.push({
				operator: '$eq',
				value: false,
				property: 'IsConnected',
				type: 'boolean'
			});
		}

		if (!equipmentActive) {
			filters.push({
				operator: '$eq',
				value: false,
				property: 'IsActive',
				type: 'boolean'
			});
		}

		if (!equipmentInActive) {
			filters.push({
				operator: '$eq',
				value: false,
				property: 'InActive',
				type: 'boolean'
			});
		}

		return filters.length ? { filter: filters } : {};
	}, [equipmentActive, equipmentInActive, extraParams, EquipmentTypeId]);


	const handleOnChangeView = useCallback(
		(view) => (event) => {
			if (typeof onChangeView === 'function') {
				onChangeView(view);
			}
		},
		[onChangeView]
	);
	return (
		<Grid container size="grow" spacing={3}>
			<Grid size={12}>
				<Card>
					<CardContent>
						<Grid container size={12}>
							<Grid container size={12}>
								<Grid size={{ xs: 2, md: 4 }} sx={{ display: 'flex', alignItems: 'center' }}>
									<Stack spacing={1} direction="row" alignItems="center">
										<IconButton title={strings.listiview} onClick={handleOnChangeView('list')}>
											<Box component="img"
												sx={{ width: theme.spacing(2), height: theme.spacing(2) }}
												src={selectedView === 'list' ? SelectedLgridIconPNG : DeselctedGridIconPng}
											/>
										</IconButton>
										<IconButton title={strings.Gridview} onClick={handleOnChangeView('grid')}>
											<Box component="img" sx={{ width: theme.spacing(2), height: theme.spacing(2) }}
												src={selectedView === 'grid' ? SelectedListIconPng : DeselctedListIconPng}
											/>
										</IconButton>
									</Stack>
								</Grid>
								<Grid size={{ xs: 5, md: 3 }} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
									<Stack spacing={1} direction="row" justifyContent="center" alignItems="center">
										<Typography variant="h5">{strings.EquipmentList}</Typography>
									</Stack>
								</Grid>
								<Grid size={4}>
									<Stack spacing={1} direction="row" alignItems="center" sx={{ justifyContent: { xs: 'center', md: 'flex-end' } }}>
										<FormControlLabel
											control={
												<Checkbox title={strings.ActiveView}
													onChange={(e) => setEquipmentActive(e.target.checked)}
													checked={equipmentActive}
													label={strings.Active}
												/>
											}
											label={strings.Active}
										/>
										<FormControlLabel
											control={
												<Checkbox title={strings.InactiveView}
													onChange={(e) => setEquipmentInActive(e.target.checked)}
													checked={equipmentInActive}
													label={strings.InActive}
												/>
											}
											label={strings.InActive}
										/>
									</Stack>
								</Grid>
							</Grid>
							<Grid size={12}>
								{selectedView === 'grid' && (
									<EquipmentTable
										baseFilters={baseFilters}
										parentFilters={parentFilters}
										disableLoadPref={true}
										readOnly={false}
										onOpenForm={({ id, record }) => {
											navigate(`/equipmentinfo?id=${id}&name=${record?.EquipmentName || ''}&isSterilizer=${isSterilizer ? true : false}&isIncubator=${isIncubator ? true : false}&isFromEquipmentDetail=${true}&equipmentType=${record.EquipmentType}`, {
												state: record
											})
										}}
										setActiveRecord={() => { }}
										defaultSort={'EquipmentName ASC'}

									/>
								)}
								{selectedView === 'list' && (
									<EquipmentGridList
										component={EquipmentGridListItem}
										parentFilters={parentFilters}
										noOfitemsPerRow={3}
										disablePagination={true}
										noRecordMsg={'No Equipment Found'}
										defaultSort={'EquipmentName ASC'}
									/>
								)}
								{![consts.RoleName.Operator, consts.RoleName.Department].includes(auth.tags.RoleName) && <Grid container spacing={3} justifyContent="center" alignItems="center" >
									<Grid p={1} size={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
										<Button variant="contained" color="primary" component={Link} to={EquipmentTypeId ? `/equipmentlist?EquipmentTypeId=${EquipmentTypeId}` : `/equipmentlist`}  >
											{strings.ViewAll}
										</Button>
									</Grid>
								</Grid>}
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</Grid>
		</Grid>
	)
})

export default EquipmentListComponent